/**
 * HTTP layer for sites. Site detail and list, single-site patch, grid stats, and
 * the filtered list feed.
 *
 * Contains:
 * - fetchSites / fetchSite: reads
 * - patchSite: single-site write
 * - fetchSitesStats: site grid stats
 * - fetchJobSitesStats: services job-progress stats
 * - fetchSitesForListWithFilters: filtered site list
 */
import { Map } from 'immutable';

import apiClient from '@sophocles/http-common';
import { generateQueryParams, mapToQueryParams } from '@sophocles/utils';

export const SITES_ENDPOINT = '/sites';

export const fetchSites = queryParams =>
  apiClient.get(`${SITES_ENDPOINT}/`, { params: generateQueryParams(queryParams) }).then(res => res.data);

export const fetchSite = siteId => apiClient.get(`${SITES_ENDPOINT}/${siteId}`).then(res => res.data);

export const patchSite = (siteId, data) => apiClient.patch(`${SITES_ENDPOINT}/${siteId}/`, data).then(res => res.data);

// odl-app summary stats for the sites grid — distinct base path from
// SITES_ENDPOINT above.
export const fetchSitesStats = params => apiClient.get('odl-app/sites/stats/', { params }).then(res => res.data);

// Job-progress counts for the services site stat cards. Takes the same
// filter[...] params as the job-sites grid list (incl. filter[search]); the
// job-status params are stripped server-side so the cards drive that dimension.
export const fetchJobSitesStats = params => apiClient.get('odl-app/job-sites/stats/', { params }).then(res => res.data);

// Site-autocomplete listing: text_search over a single site group's sites with
// an extra legacy filter map. Distinct query shape from fetchSites's
// generateQueryParams listing.
export const fetchSitesForListWithFilters = (offset, limit, siteGroupId, filterObject, search, searchFields = []) => {
  const searchParams = encodeURIComponent(searchFields.join(',') + '|' + search);
  const filterParams = mapToQueryParams(Map(filterObject));
  return apiClient
    .get(
      `${SITES_ENDPOINT}/?text_search=${searchParams}&offset=${offset}&limit=${limit}&site_groups=${siteGroupId}&${filterParams}`,
    )
    .then(res => res.data);
};
